import React from 'react';

/*
interface User{
    name: string,
    email: string
    ...
} */

/*
interface shoppingCart: {
    id: string,
    _id: string,
    title: string,
    quantity: number,
    price: {
        value: number,
        offer: number
    }
    description?: string
    ...
}[] */

const UserContext = React.createContext({
    user: undefined,
    token: undefined,
    settings: undefined,
    shoppingCart: undefined,
    isTokenVerified: undefined,
    setIsTokenVerified: (value: any) => { },
    setUser: (value: any) => { },
    setSettings: (value: any) => { },
    setToken: (value: any) => { },
    setShoppingCart: (value: any) => { }
})

export default UserContext